import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { webDataDrawerElements } from "data/radhamaniPageData";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ArrowBackRounded, KeyboardBackspaceRounded } from "@mui/icons-material";
import { replenishmentDrawerElements } from "./data";
import { IconButton, Typography } from "@mui/material";
import LogicProfiles from "./Replenishment/LogicProfiles/LogicProfiles";
import ExecuteLogics from "./Replenishment/ExecuteLogics/ExecuteLogics";
import FileUpload from "./Replenishment/FileUpload/FileUpload";
import SelectedLogicProfile from "./Replenishment/SelectedLogicProfile/SelectedLogicProfile";
import ReplJobs from "./Replenishment/ReplJobs/ReplJobs";
import SelectedJob from "./Replenishment/SelectedJob/SelectedJob";

const ReplenishmentDashboard = () => {
	const [pathName, service] = useOutletContext();
	const navigate = useNavigate();
	const tabComponents = {
		[replenishmentDrawerElements.replenishment.types.repl_logics.key]: {
			...replenishmentDrawerElements.replenishment.types.repl_logics,
			component: <LogicProfiles activeService={service} />,
		},
		[replenishmentDrawerElements.replenishment.types.execute_logics.key]: {
			...replenishmentDrawerElements.replenishment.types.execute_logics,
			component: <ExecuteLogics activeService={service} />,
		},
		[replenishmentDrawerElements.replenishment.types.repl_upload_files.key]: {
			...replenishmentDrawerElements.replenishment.types.repl_upload_files,
			component: <FileUpload activeService={service} />,
		},
		[replenishmentDrawerElements.replenishment.types.repl_selected_logic.key]: {
			...replenishmentDrawerElements.replenishment.types.repl_selected_logic,
			component: <SelectedLogicProfile activeService={service} />,
		},
		[replenishmentDrawerElements.replenishment.types.repl_selected_job.key]: {
			...replenishmentDrawerElements.replenishment.types.repl_selected_job,
			component: <SelectedJob activeService={service} />,
		},
		// [replenishmentDrawerElements.replenishment.types.repl_jobs.key]: {
		// 	...replenishmentDrawerElements.replenishment.types.repl_jobs,
		// 	component: <ReplJobs />,
		// },
	};
	return (
		<Box sx={{ width: "100%" }}>
			<Box display="flex" alignItems="center" columnGap={1}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Typography variant="h5">{service?.name}</Typography>
			</Box>
			<Box width="95%" margin="auto">
				{tabComponents?.[pathName]?.component}
			</Box>

			{/* {tabComponents&&
				tabComponents.map((row) => (
					<Box width="95%" margin="auto" key={row.key} display={row.key === pathName ? "block" : "none"}>
						{row.component}
					</Box>
				))} */}
		</Box>
	);
};

export default ReplenishmentDashboard;
